import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'feedback-sidebar-due-date',
    events: {
        'click .pick-a-date'                     : 'pickADate',
        'change input[name="feedback_due_date"]' : 'onChangeFeedbacksDueDate',
        'submit form'                            : 'submit'
    },

    dom_handlers: {
        pickADate: function(e) {
            var type = $(e.currentTarget).data('type');
            if (type === 'tomorrow' || type === 'next_monday') {
                this.doChangeFeedbacksDueDate(type);
            } else if (type === 'clear') {
                this.doChangeFeedbacksDueDate('clear');
            } else {
                this.$el.find('input[name="feedback_due_date"]').get(0).showPicker();
            }
        },

        onChangeFeedbacksDueDate: function(e) {
            var due_date = $(e.currentTarget).val();
            this.doChangeFeedbacksDueDate(due_date);
        },
        submit: function(e) {
            e.preventDefault();
            this.trigger('Submit:DueDate', this.due_date);
        }
    },
    initialize: function() {
        this.due_date = '';
    },
    doChangeFeedbacksDueDate: function(due_date) {
        this.due_date = due_date;

        this.renderOptions();
    },
    renderOptions: function() {
        var options =
        '<li class="pick-a-date" data-type="clear">Clear due date</li>' +
        '<li class="separator"></li>' +
        '<li class="pick-a-date" data-type="tomorrow">' +
            '<div class="flex-between">' +
                '<span>Tomorrow</span>' +
                '<span class="text-info margin-left-24">' + Util.getTomorrow('dddd') + '</span>' +
            '</div>' +
        '</li>' +
        '<li class="pick-a-date" data-type="next_monday">' +
            '<div class="flex-between">' +
                '<span>Next week</span>' +
                '<span class="text-info margin-left-24">' + Util.getNextMonday('dddd') + '</span>' +
            '</div>' +
        '</li>' +
        '<li class="pick-a-date">Pick a date</li>';

        this.$el.find('.due-date-options').html(options);

        if (this.due_date === 'clear') {
            this.$el.find('.feedback-due-date-text').text('No due date');
        } else if (this.due_date === 'tomorrow') {
            this.$el.find('.feedback-due-date-text').text(Util.getTomorrow('DD MMM YYYY'));
        } else if (this.due_date === 'next_monday') {
            this.$el.find('.feedback-due-date-text').text(Util.getNextMonday('DD MMM YYYY'));
        } else if (this.due_date === '') {
            this.$el.find('.feedback-due-date-text').html('<span class="placeholder-text">Select...</span>');
        } else {
            // format due_date from yyyy-mm-dd to dd MMM yyyy
            var due_date = Util.dateStringToTimestamp(this.due_date, 'YYYY-MM-DD');
            this.$el.find('.feedback-due-date-text').text(Util.moment(due_date, 'DD MMM YYYY', false, false, false));
        }
    },
    render: function() {
        var content =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Due date</div>' +
                '<div class="position-relative">' +
                    '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false">' +
                        '<button type="button" class="dropdown-select dropdown-select-multiple feedback-due-date-text">' +
                            '<span class="placeholder-text">Select...</span>' +
                        '</button>' +
                        '<div>' +
                            '<ul class="dropdown due-date-options"></ul>' +
                        '</div>' +
                    '</div>' +
                    '<input type="date" name="feedback_due_date" class="hidden-date-picker">' +
                '</div>' +
            '</div>' +
            '<div class="flex-end">' +
                '<button type="submit" class="primary">Change</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        this.renderOptions();
        return this;
    }
});